import { OptionServiceType } from '../models/enums';
import { calculateBasePrice } from './helperFunctions';
import AppState from '../AppState';
/**
 * Add basic plan to the selected plan.
 *
 * @param {AvailableSelections} plan - The selected plan.
 * @returns {Array} - The updated plan with the basic plan added.
 */
const addBasicPlan = (plan) => {
    const sfpModel = AppState.get('serviceFunnelPackage');
    const price = calculateBasePrice(plan);
    const internetBasicConfig = [
        {
            'id': 'FBR25C1C',
            'upload': 25000,
            'download': 10000,
            'desc': 'Standard Fixed Wireless',
        },
        {
            'id': 'FBR25C1C',
            'upload': 25000,
            'download': 10000,
            'desc': 'Standard',
        },
    ];
    const newPlan = [];
    if (sfpModel.serviceType === OptionServiceType.WIRELESS) {
        newPlan.push({
            OptionFee: 0,
            PlanIdentifier: internetBasicConfig[0].id,
            PlanName: internetBasicConfig[0].desc,
            upload: (internetBasicConfig[0].upload / 1000).toString(),
            download: (internetBasicConfig[0].download / 1000).toString(),
            price: price,
            modemCost: sfpModel.internetSelection.modemCost,
        });
        return newPlan;
    }
    if (!sfpModel.availableSelections.find((option) => option.PlanIdentifier === 'SBCHRG9' || option.PlanIdentifier === 'SBCHRG11')) {
        newPlan.push({
            OptionFee: 0,
            PlanIdentifier: internetBasicConfig[1].id,
            PlanName: internetBasicConfig[1].desc,
            upload: (internetBasicConfig[1].upload / 1000).toString(),
            download: (internetBasicConfig[1].download / 1000).toString(),
            price: price,
            modemCost: sfpModel.internetSelection.modemCost,
        });
    }
    return newPlan;
};
export default addBasicPlan;
